import menu from "./modules/menu";
import home from "./modules/home";
import dataCorrection from "./modules/dataCorrection";
import common from "./modules/common";
import workbench from "./modules/workbench";

export default{
    menu: menu, // 菜单
    home: home,
    dataCorrection: dataCorrection, // 数据修正
    common: common, // 通用
    workbench: workbench, // 工作台
    message: {
        username: 'User Name',
        password: 'Password',
        login: 'Login',
        captcha: 'Captcha',
        forgetPassword: 'Forget Password?',
        loginTip: 'The login result is random. Just fill in the captcha',
        editpassword: 'Edit Password',
        logout: 'Logout',
        errMsg: {
            inputRequired: 'Please Input {cont}',
            selectRequired: 'Please Select {cont}'
        }
    },
}

